// Task vocabulary shared by the Tasks page and the per-client Tasks tab.
// Kept in one place so a new status/category shows up in every task form.

export const STATUSES = [
  { v: "todo", label: "To do" },
  { v: "in_progress", label: "In progress" },
  { v: "review", label: "Review" },
  { v: "done", label: "Done" },
];

export const PRIORITIES = ["low", "medium", "high", "urgent"];

export const CATEGORIES = [
  { v: "gst", label: "GST", tone: "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/30" },
  { v: "income_tax", label: "Income Tax", tone: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/30" },
  { v: "roc", label: "ROC", tone: "bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/30" },
  { v: "tax_audit", label: "Tax Audit", tone: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/30" },
  { v: "statutory_audit", label: "Statutory Audit", tone: "bg-rose-500/10 text-rose-700 dark:text-rose-300 border-rose-500/30" },
  { v: "other", label: "Others", tone: "bg-muted text-muted-foreground border-border" },
];

export const PRIORITY_TONE = {
  low: "text-muted-foreground",
  medium: "text-blue-600 dark:text-blue-400",
  high: "text-amber-600 dark:text-amber-400",
  urgent: "text-red-600 dark:text-red-400",
};

// Blank new-task form. A factory (not a shared object) so each dialog gets its
// own state and resetting one form never mutates another's.
export const emptyTaskForm = () => ({
  title: "",
  description: "",
  client_id: "none",
  assignee_id: "none",
  priority: "medium",
  task_status: "todo",
  category: "none",
  due_date: null,
});
